import { Scene } from "phaser";
import { getResolution } from "../lib/config";
import { eventDispatcher } from "../lib/eventDispatcher";

export class HUD extends Scene {
  btnNext: Phaser.GameObjects.Image;
  btnPrev: Phaser.GameObjects.Image;
  btnFullscreen: Phaser.GameObjects.Image;
  btnFsisActive: boolean = false;
  btnShare: Phaser.GameObjects.Image;
  btnFacebok: Phaser.GameObjects.Image;
  btnTwitter: Phaser.GameObjects.Image;
  btnWhatsapp: Phaser.GameObjects.Image;
  postal: Phaser.GameObjects.Image;
  isBtnActive: boolean = true;
  isSocialActive: boolean = false;
  emitter: any;
  fullScreenState: boolean = false;

  constructor() {
    super("HUD");
  }

  create() {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const { width, height } = getResolution();
    const scene = this;
    // Button
    this.btnPrev = this.add
      .image(width * 0.01, height / 2, "prev")
      .setScale(0.7)
      .setOrigin(0, 0.5)
      .setScrollFactor(0)
      .setInteractive();
    this.btnNext = this.add
      .image(width * 0.99, height / 2, "next")
      .setScale(0.7)
      .setOrigin(1, 0.5)
      .setScrollFactor(0)
      .setInteractive();
    this.btnFullscreen = this.add
      .image(width * 0.99, height * 0.05, "fullscreenOff")
      .setScale(0.8)
      .setOrigin(1, 0.5)
      .setScrollFactor(0)
      .setInteractive();
    // Hover Config
    this.btnFullscreen.on("pointerover", () => {
      !this.btnFsisActive && this.btnFullscreen.setTexture("fson");
    });
    this.btnFullscreen.on(
      "pointerout",
      () =>
        !this.btnFsisActive && this.btnFullscreen.setTexture("fullscreenOff")
    );
    this.btnNext.on("pointerover", () => {
      this.btnNext.setTexture("nextOn");
    });
    this.btnNext.on("pointerout", () => this.btnNext.setTexture("next"));
    this.btnPrev.on("pointerover", () => {
      this.btnPrev.setTexture("prevOn");
    });
    this.btnPrev.on("pointerout", () => this.btnPrev.setTexture("prev"));
    // Social
    this.btnShare = this.add
      .image(width * 0.99, height * 0.13, "share")
      .setScale(0.8)
      .setOrigin(1, 0.5)
      .setScrollFactor(0)
      .setInteractive();
    this.btnShare.on("pointerover", () => {
      !this.isSocialActive && this.btnShare.setTexture("shareOn");
    });
    this.btnShare.on(
      "pointerout",
      () => !this.isSocialActive && this.btnShare.setTexture("share")
    );
    this.btnShare.on("pointerdown", () => openShareOption());

    const animSocialBtn = (btn: any, alpha: number) => {
      this.tweens.add({
        targets: btn,
        props: {
          alpha: { value: alpha, duration: 500 },
        },
      });
    };

    const openShareOption = () => {
      if (this.isSocialActive) {
        this.isSocialActive = false;
        this.btnShare.setTexture("share");
        animSocialBtn(this.btnFacebok, 0);
        animSocialBtn(this.btnWhatsapp, 0);
        animSocialBtn(this.btnTwitter, 0);
      } else {
        this.isSocialActive = true;
        this.btnShare.setTexture("shareOn");
        animSocialBtn(this.btnFacebok, 1);
        animSocialBtn(this.btnWhatsapp, 1);
        animSocialBtn(this.btnTwitter, 1);
      }
    };
    // Facebook
    this.btnFacebok = this.add
      .image(width * 0.99, height * 0.29, "fb")
      .setScale(0.8)
      .setOrigin(1, 0.5)
      .setScrollFactor(0)
      .setAlpha(0)
      .setInteractive();
    this.btnFacebok.on("pointerover", () => {
      this.btnFacebok.setTexture("fbOn");
    });
    this.btnFacebok.on("pointerout", () => this.btnFacebok.setTexture("fb"));
    this.btnFacebok.on("pointerdown", () => {
      this.openLink(
        "https://www.facebook.com/sharer/sharer.php?u=https%3A//www.parqueexplora.org/mapa-interactivo-el-viaje-del-beagle"
      );
    });
    // Whatsapp
    this.btnWhatsapp = this.add
      .image(width * 0.99, height * 0.21, "wapp")
      .setScale(0.8)
      .setOrigin(1, 0.5)
      .setScrollFactor(0)
      .setAlpha(0)
      .setInteractive();
    this.btnWhatsapp.on("pointerover", () => {
      this.btnWhatsapp.setTexture("wappOn");
    });
    this.btnWhatsapp.on("pointerout", () =>
      this.btnWhatsapp.setTexture("wapp")
    );
    this.btnWhatsapp.on("pointerdown", () => {
      this.openLink(
        "https://api.whatsapp.com/send?text=%20%C2%A1Emprende%20un%20viaje%20fascinante%20a%20bordo%20del%20HMS%20Beagle!%20Descubre%20c%C3%B3mo%20Charles%20Darwin%20revolucion%C3%B3%20la%20ciencia%20con%20sus%20observaciones%20en%20esta%20expedici%C3%B3n%20%C3%A9pica.%20%0A%0AEnlace%3A%20https%3A%2F%2Fwww.parqueexplora.org%2Fmapa-interactivo-el-viaje-del-beagle"
      );
    });
    // X
    this.btnTwitter = this.add
      .image(width * 0.99, height * 0.37, "twitter")
      .setScale(0.8)
      .setOrigin(1, 0.5)
      .setScrollFactor(0)
      .setAlpha(0)
      .setInteractive();
    this.btnTwitter.on("pointerover", () => {
      this.btnTwitter.setTexture("twitterOn");
    });
    this.btnTwitter.on("pointerout", () =>
      this.btnTwitter.setTexture("twitter")
    );
    this.btnTwitter.on("pointerdown", () => {
      this.openLink(
        "https://x.com/intent/tweet?text=%C2%A1Conoce%20el%20viaje%20fascinante%20a%20bordo%20del%20HMS%20Beagle!%20Descubre%20c%C3%B3mo%20Charles%20Darwin%20revolucion%C3%B3%20la%20ciencia%20con%20sus%20observaciones%20en%20esta%20expedici%C3%B3n%20%C3%A9pica.%20%20%23ViajeDelBeagle%20%23CienciaParaTodos%20%23ParqueExplora%22&url=https%3A%2F%2Fwww.parqueexplora.org%2Fmapa-interactivo-el-viaje-del-beagle"
      );
    });
    // Button Actions
    this.btnNext.on("pointerdown", () => {
      this.isBtnActive && eventDispatcher.emit("NEXT");
    });
    this.btnPrev.on("pointerdown", () => {
      this.isBtnActive && eventDispatcher.emit("PREV");
    });

    this.btnFullscreen.setInteractive().on("pointerdown", () => {
      this.toggleFullscreen();
      /* if (scene.scale.isFullscreen) {
        scene.scale.stopFullscreen();
        btnFsActive(false);
        // On stop fulll screen
      } else {
        scene.scale.startFullscreen();
        btnFsActive(true);
        // On start fulll screen
      } */
    });
    const btnFsActive = (state: boolean) => {
      this.btnFullscreen.setTexture("fson");
      if (state) {
        this.btnFsisActive = true;
        this.btnFullscreen.setTexture("fson");
      } else {
        this.btnFsisActive = false;
        this.btnFullscreen.setTexture("fullscreenOff");
      }
    };
    // Active Buttons
    eventDispatcher.on(
      "BTN-ON",
      () => {
        this.time.delayedCall(1000, () => (this.isBtnActive = true), [], this);
        /* this.isBtnActive = true; */
      },
      this
    );
    eventDispatcher.on(
      "BTN-OFF",
      () => {
        this.isBtnActive = false;
      },
      this
    );

    // Postal Viewer
    this.postal = this.add.image(0, 0, "postal1").setOrigin(0, 0);
    this.postal.setPosition(0, 0).setDepth(2).setAlpha(0);
    this.postal.setPosition(
      width / 2 - this.postal.width / 2,
      height / 2 - this.postal.height / 2
    );

    // Active Anim
    let tween: any; // dynamnic data anim
    const postalViewer = (name: string, alpha: number) => {
      name && this.postal.setTexture(name);
      tween = this.tweens.add({
        targets: this.postal,
        alpha: alpha,
        duration: 250,
        ease: "Power1",
        onComplete: () => (this.isBtnActive = true),
      });
    };

    // Postal Listen Action
    eventDispatcher.on(
      "POSTAL-SHOW",
      (e: any) => {
        this.postal.alpha == 0 && postalViewer(e.name, 1);
      },
      this
    );
    eventDispatcher.on(
      "POSTAL-HIDDEN",
      (e: any) => {
        this.postal.alpha == 1 && postalViewer(e.name, 0);
      },
      this
    );
  }
  openLink(url: string) {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank"; // Esto hace que se abra en una nueva pestaña
    link.rel = "noopener noreferrer"; // Seguridad adicional
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  toggleFullscreen() {
    var elem = document.getElementById("game-container");
    if (!this.fullScreenState) {
      this.fullScreenState = true;
      if (elem?.requestFullscreen) {
        elem?.requestFullscreen();
      } else if (elem?.mozRequestFullScreen) {
        /* Firefox */
        elem?.mozRequestFullScreen();
      } else if (elem?.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem?.webkitRequestFullscreen();
      } else if (elem?.msRequestFullscreen) {
        /* IE/Edge */
        elem?.msRequestFullscreen();
      }
    } else {
      this.fullScreenState = false;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }
}
